export enum ExplanationType {
   Context,
   MoreDetail,
   Untranslatable,
   None,
}

const detailedExplanationStarters = /^(It's|The|A|An|Scientific) /i
const contextExplanationStarters = /^(Refers|Referring|In) /i

export const getExplanationType = (
   explanation: string | undefined,
   meaning: string | undefined
): ExplanationType => {
   if (!explanation) return ExplanationType.None
   if (!meaning || !meaning.length) return ExplanationType.Untranslatable
   if (detailedExplanationStarters.test(explanation)) return ExplanationType.MoreDetail
   if (contextExplanationStarters.test(explanation)) return ExplanationType.Context
   if (explanation.length < 50) return ExplanationType.Context
   return ExplanationType.MoreDetail
}
